<script setup lang="ts">
defineProps({
  hasPrice: {
    type: Boolean,
    default: true
  }
})
</script>

<template>
  <div aria-hidden="true">
    <USkeleton class="w-full h-32 sm:h-48 rounded-xl" />
    <div class="mt-4 flex flex-col gap-1">
      <USkeleton class="w-16 h-5 rounded-xl" />
      <USkeleton class="w-1/2 h-8 rounded-xl" />
    </div>
    <div v-if="hasPrice" class="mt-4">
      <USkeleton class="w-1/4 h-6 rounded-xl" />
    </div>
  </div>
</template>
